// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_comp_plan.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { GenericPayloadResponse, MultiGenericPayloadResponse } from "./stcs_commons.entity";
import { StcsCompPlanCfg } from "./stcs_comp_plan_cfg.entity";

export const protobufPackage = "stcs_cmw";

export interface CompPlanCfgActivateRequest {
  ref_id_user: string;
  comp_plan_cfg: StcsCompPlanCfg | undefined;
}

export interface CompPlanCfgDeactivateRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  ref_id_comp_plan_cfg: string;
}

export interface CompPlanCfgCalcRequest {
  ref_id_user: string;
  comp_plan_cfg: StcsCompPlanCfg | undefined;
}

export interface CompPlanCfgCreateRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  fpna_begin_date_string: string;
  fpna_end_date_string: string;
  display_name: string;
  ref_id_comp_plan_cfg_template?: string | undefined;
}

export interface CompPlanCfgDelRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp_plan_cfg: string;
}

export interface CompPlanCfgSaveRequest {
  ref_id_user: string;
  comp_plan_cfg: StcsCompPlanCfg | undefined;
}

export interface CompPlanCfgGetRequest {
  ref_id_org: string;
  ref_id_comp_plan_cfg: string;
  ref_id_user: string;
}

export interface CompPlanCfgListRequest {
  ref_id_comp: string;
  ref_id_org: string;
  ref_id_user: string;
}

export interface RollingForecastResValuesGetRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  ref_id_comp_plan_cfg: string;
}

export interface CompPlanResValuesGetRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  ref_id_comp_plan_cfg: string;
}

export interface CompPlanRfGetRequest {
  ref_id_user: string;
  ref_id_org: string;
  ref_id_comp: string;
  ref_id_comp_plan_cfg: string;
  fpna_begin_date_string: string;
}

function createBaseCompPlanCfgActivateRequest(): CompPlanCfgActivateRequest {
  return { ref_id_user: "", comp_plan_cfg: undefined };
}

export const CompPlanCfgActivateRequest: MessageFns<CompPlanCfgActivateRequest> = {
  encode(message: CompPlanCfgActivateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.comp_plan_cfg !== undefined) {
      StcsCompPlanCfg.encode(message.comp_plan_cfg, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgActivateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgActivateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comp_plan_cfg = StcsCompPlanCfg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgActivateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      comp_plan_cfg: isSet(object.comp_plan_cfg) ? StcsCompPlanCfg.fromJSON(object.comp_plan_cfg) : undefined,
    };
  },

  toJSON(message: CompPlanCfgActivateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.comp_plan_cfg !== undefined) {
      obj.comp_plan_cfg = StcsCompPlanCfg.toJSON(message.comp_plan_cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgActivateRequest>, I>>(base?: I): CompPlanCfgActivateRequest {
    return CompPlanCfgActivateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgActivateRequest>, I>>(object: I): CompPlanCfgActivateRequest {
    const message = createBaseCompPlanCfgActivateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.comp_plan_cfg = (object.comp_plan_cfg !== undefined && object.comp_plan_cfg !== null)
      ? StcsCompPlanCfg.fromPartial(object.comp_plan_cfg)
      : undefined;
    return message;
  },
};

function createBaseCompPlanCfgDeactivateRequest(): CompPlanCfgDeactivateRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", ref_id_comp_plan_cfg: "" };
}

export const CompPlanCfgDeactivateRequest: MessageFns<CompPlanCfgDeactivateRequest> = {
  encode(message: CompPlanCfgDeactivateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(34).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgDeactivateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgDeactivateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgDeactivateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
    };
  },

  toJSON(message: CompPlanCfgDeactivateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgDeactivateRequest>, I>>(base?: I): CompPlanCfgDeactivateRequest {
    return CompPlanCfgDeactivateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgDeactivateRequest>, I>>(object: I): CompPlanCfgDeactivateRequest {
    const message = createBaseCompPlanCfgDeactivateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    return message;
  },
};

function createBaseCompPlanCfgCalcRequest(): CompPlanCfgCalcRequest {
  return { ref_id_user: "", comp_plan_cfg: undefined };
}

export const CompPlanCfgCalcRequest: MessageFns<CompPlanCfgCalcRequest> = {
  encode(message: CompPlanCfgCalcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.comp_plan_cfg !== undefined) {
      StcsCompPlanCfg.encode(message.comp_plan_cfg, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgCalcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgCalcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comp_plan_cfg = StcsCompPlanCfg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgCalcRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      comp_plan_cfg: isSet(object.comp_plan_cfg) ? StcsCompPlanCfg.fromJSON(object.comp_plan_cfg) : undefined,
    };
  },

  toJSON(message: CompPlanCfgCalcRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.comp_plan_cfg !== undefined) {
      obj.comp_plan_cfg = StcsCompPlanCfg.toJSON(message.comp_plan_cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgCalcRequest>, I>>(base?: I): CompPlanCfgCalcRequest {
    return CompPlanCfgCalcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgCalcRequest>, I>>(object: I): CompPlanCfgCalcRequest {
    const message = createBaseCompPlanCfgCalcRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.comp_plan_cfg = (object.comp_plan_cfg !== undefined && object.comp_plan_cfg !== null)
      ? StcsCompPlanCfg.fromPartial(object.comp_plan_cfg)
      : undefined;
    return message;
  },
};

function createBaseCompPlanCfgCreateRequest(): CompPlanCfgCreateRequest {
  return {
    ref_id_user: "",
    ref_id_org: "",
    ref_id_comp: "",
    fpna_begin_date_string: "",
    fpna_end_date_string: "",
    display_name: "",
    ref_id_comp_plan_cfg_template: undefined,
  };
}

export const CompPlanCfgCreateRequest: MessageFns<CompPlanCfgCreateRequest> = {
  encode(message: CompPlanCfgCreateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(34).string(message.fpna_begin_date_string);
    }
    if (message.fpna_end_date_string !== "") {
      writer.uint32(42).string(message.fpna_end_date_string);
    }
    if (message.display_name !== "") {
      writer.uint32(50).string(message.display_name);
    }
    if (message.ref_id_comp_plan_cfg_template !== undefined) {
      writer.uint32(58).string(message.ref_id_comp_plan_cfg_template);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgCreateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgCreateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_end_date_string = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.display_name = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.ref_id_comp_plan_cfg_template = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgCreateRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
      fpna_end_date_string: isSet(object.fpna_end_date_string) ? globalThis.String(object.fpna_end_date_string) : "",
      display_name: isSet(object.display_name) ? globalThis.String(object.display_name) : "",
      ref_id_comp_plan_cfg_template: isSet(object.ref_id_comp_plan_cfg_template)
        ? globalThis.String(object.ref_id_comp_plan_cfg_template)
        : undefined,
    };
  },

  toJSON(message: CompPlanCfgCreateRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    if (message.fpna_end_date_string !== "") {
      obj.fpna_end_date_string = message.fpna_end_date_string;
    }
    if (message.display_name !== "") {
      obj.display_name = message.display_name;
    }
    if (message.ref_id_comp_plan_cfg_template !== undefined) {
      obj.ref_id_comp_plan_cfg_template = message.ref_id_comp_plan_cfg_template;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgCreateRequest>, I>>(base?: I): CompPlanCfgCreateRequest {
    return CompPlanCfgCreateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgCreateRequest>, I>>(object: I): CompPlanCfgCreateRequest {
    const message = createBaseCompPlanCfgCreateRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    message.fpna_end_date_string = object.fpna_end_date_string ?? "";
    message.display_name = object.display_name ?? "";
    message.ref_id_comp_plan_cfg_template = object.ref_id_comp_plan_cfg_template ?? undefined;
    return message;
  },
};

function createBaseCompPlanCfgDelRequest(): CompPlanCfgDelRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp_plan_cfg: "" };
}

export const CompPlanCfgDelRequest: MessageFns<CompPlanCfgDelRequest> = {
  encode(message: CompPlanCfgDelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(26).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgDelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgDelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgDelRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
    };
  },

  toJSON(message: CompPlanCfgDelRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgDelRequest>, I>>(base?: I): CompPlanCfgDelRequest {
    return CompPlanCfgDelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgDelRequest>, I>>(object: I): CompPlanCfgDelRequest {
    const message = createBaseCompPlanCfgDelRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    return message;
  },
};

function createBaseCompPlanCfgSaveRequest(): CompPlanCfgSaveRequest {
  return { ref_id_user: "", comp_plan_cfg: undefined };
}

export const CompPlanCfgSaveRequest: MessageFns<CompPlanCfgSaveRequest> = {
  encode(message: CompPlanCfgSaveRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.comp_plan_cfg !== undefined) {
      StcsCompPlanCfg.encode(message.comp_plan_cfg, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgSaveRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgSaveRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.comp_plan_cfg = StcsCompPlanCfg.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgSaveRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      comp_plan_cfg: isSet(object.comp_plan_cfg) ? StcsCompPlanCfg.fromJSON(object.comp_plan_cfg) : undefined,
    };
  },

  toJSON(message: CompPlanCfgSaveRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.comp_plan_cfg !== undefined) {
      obj.comp_plan_cfg = StcsCompPlanCfg.toJSON(message.comp_plan_cfg);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgSaveRequest>, I>>(base?: I): CompPlanCfgSaveRequest {
    return CompPlanCfgSaveRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgSaveRequest>, I>>(object: I): CompPlanCfgSaveRequest {
    const message = createBaseCompPlanCfgSaveRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.comp_plan_cfg = (object.comp_plan_cfg !== undefined && object.comp_plan_cfg !== null)
      ? StcsCompPlanCfg.fromPartial(object.comp_plan_cfg)
      : undefined;
    return message;
  },
};

function createBaseCompPlanCfgGetRequest(): CompPlanCfgGetRequest {
  return { ref_id_org: "", ref_id_comp_plan_cfg: "", ref_id_user: "" };
}

export const CompPlanCfgGetRequest: MessageFns<CompPlanCfgGetRequest> = {
  encode(message: CompPlanCfgGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_org !== "") {
      writer.uint32(10).string(message.ref_id_org);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(18).string(message.ref_id_comp_plan_cfg);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(26).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgGetRequest {
    return {
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
    };
  },

  toJSON(message: CompPlanCfgGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgGetRequest>, I>>(base?: I): CompPlanCfgGetRequest {
    return CompPlanCfgGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgGetRequest>, I>>(object: I): CompPlanCfgGetRequest {
    const message = createBaseCompPlanCfgGetRequest();
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseCompPlanCfgListRequest(): CompPlanCfgListRequest {
  return { ref_id_comp: "", ref_id_org: "", ref_id_user: "" };
}

export const CompPlanCfgListRequest: MessageFns<CompPlanCfgListRequest> = {
  encode(message: CompPlanCfgListRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_comp !== "") {
      writer.uint32(10).string(message.ref_id_comp);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_user !== "") {
      writer.uint32(26).string(message.ref_id_user);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanCfgListRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanCfgListRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanCfgListRequest {
    return {
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
    };
  },

  toJSON(message: CompPlanCfgListRequest): unknown {
    const obj: any = {};
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanCfgListRequest>, I>>(base?: I): CompPlanCfgListRequest {
    return CompPlanCfgListRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanCfgListRequest>, I>>(object: I): CompPlanCfgListRequest {
    const message = createBaseCompPlanCfgListRequest();
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_user = object.ref_id_user ?? "";
    return message;
  },
};

function createBaseRollingForecastResValuesGetRequest(): RollingForecastResValuesGetRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", ref_id_comp_plan_cfg: "" };
}

export const RollingForecastResValuesGetRequest: MessageFns<RollingForecastResValuesGetRequest> = {
  encode(message: RollingForecastResValuesGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(34).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RollingForecastResValuesGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRollingForecastResValuesGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RollingForecastResValuesGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
    };
  },

  toJSON(message: RollingForecastResValuesGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RollingForecastResValuesGetRequest>, I>>(
    base?: I,
  ): RollingForecastResValuesGetRequest {
    return RollingForecastResValuesGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RollingForecastResValuesGetRequest>, I>>(
    object: I,
  ): RollingForecastResValuesGetRequest {
    const message = createBaseRollingForecastResValuesGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    return message;
  },
};

function createBaseCompPlanResValuesGetRequest(): CompPlanResValuesGetRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", ref_id_comp_plan_cfg: "" };
}

export const CompPlanResValuesGetRequest: MessageFns<CompPlanResValuesGetRequest> = {
  encode(message: CompPlanResValuesGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(34).string(message.ref_id_comp_plan_cfg);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanResValuesGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanResValuesGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanResValuesGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
    };
  },

  toJSON(message: CompPlanResValuesGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanResValuesGetRequest>, I>>(base?: I): CompPlanResValuesGetRequest {
    return CompPlanResValuesGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanResValuesGetRequest>, I>>(object: I): CompPlanResValuesGetRequest {
    const message = createBaseCompPlanResValuesGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    return message;
  },
};

function createBaseCompPlanRfGetRequest(): CompPlanRfGetRequest {
  return { ref_id_user: "", ref_id_org: "", ref_id_comp: "", ref_id_comp_plan_cfg: "", fpna_begin_date_string: "" };
}

export const CompPlanRfGetRequest: MessageFns<CompPlanRfGetRequest> = {
  encode(message: CompPlanRfGetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    if (message.ref_id_comp !== "") {
      writer.uint32(26).string(message.ref_id_comp);
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      writer.uint32(34).string(message.ref_id_comp_plan_cfg);
    }
    if (message.fpna_begin_date_string !== "") {
      writer.uint32(42).string(message.fpna_begin_date_string);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CompPlanRfGetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompPlanRfGetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ref_id_comp = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.ref_id_comp_plan_cfg = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fpna_begin_date_string = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompPlanRfGetRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      ref_id_comp: isSet(object.ref_id_comp) ? globalThis.String(object.ref_id_comp) : "",
      ref_id_comp_plan_cfg: isSet(object.ref_id_comp_plan_cfg) ? globalThis.String(object.ref_id_comp_plan_cfg) : "",
      fpna_begin_date_string: isSet(object.fpna_begin_date_string)
        ? globalThis.String(object.fpna_begin_date_string)
        : "",
    };
  },

  toJSON(message: CompPlanRfGetRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.ref_id_comp !== "") {
      obj.ref_id_comp = message.ref_id_comp;
    }
    if (message.ref_id_comp_plan_cfg !== "") {
      obj.ref_id_comp_plan_cfg = message.ref_id_comp_plan_cfg;
    }
    if (message.fpna_begin_date_string !== "") {
      obj.fpna_begin_date_string = message.fpna_begin_date_string;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompPlanRfGetRequest>, I>>(base?: I): CompPlanRfGetRequest {
    return CompPlanRfGetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompPlanRfGetRequest>, I>>(object: I): CompPlanRfGetRequest {
    const message = createBaseCompPlanRfGetRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    message.ref_id_comp = object.ref_id_comp ?? "";
    message.ref_id_comp_plan_cfg = object.ref_id_comp_plan_cfg ?? "";
    message.fpna_begin_date_string = object.fpna_begin_date_string ?? "";
    return message;
  },
};

export interface StcsWappSvcCompPlan {
  comp_plan_cfg_activate(
    request: DeepPartial<CompPlanCfgActivateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_plan_cfg_calc(
    request: DeepPartial<CompPlanCfgCalcRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_plan_cfg_create(
    request: DeepPartial<CompPlanCfgCreateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_plan_cfg_deactivate(
    request: DeepPartial<CompPlanCfgDeactivateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_plan_cfg_delete(
    request: DeepPartial<CompPlanCfgDelRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_plan_cfg_get(
    request: DeepPartial<CompPlanCfgGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
  comp_plan_cfg_list(
    request: DeepPartial<CompPlanCfgListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_plan_cfg_save(
    request: DeepPartial<CompPlanCfgSaveRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_plan_res_values_get(
    request: DeepPartial<CompPlanResValuesGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse>;
  comp_plan_rf_res_values_get(
    request: DeepPartial<CompPlanRfGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
}

export class StcsWappSvcCompPlanClientImpl implements StcsWappSvcCompPlan {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.comp_plan_cfg_activate = this.comp_plan_cfg_activate.bind(this);
    this.comp_plan_cfg_calc = this.comp_plan_cfg_calc.bind(this);
    this.comp_plan_cfg_create = this.comp_plan_cfg_create.bind(this);
    this.comp_plan_cfg_deactivate = this.comp_plan_cfg_deactivate.bind(this);
    this.comp_plan_cfg_delete = this.comp_plan_cfg_delete.bind(this);
    this.comp_plan_cfg_get = this.comp_plan_cfg_get.bind(this);
    this.comp_plan_cfg_list = this.comp_plan_cfg_list.bind(this);
    this.comp_plan_cfg_save = this.comp_plan_cfg_save.bind(this);
    this.comp_plan_res_values_get = this.comp_plan_res_values_get.bind(this);
    this.comp_plan_rf_res_values_get = this.comp_plan_rf_res_values_get.bind(this);
  }

  comp_plan_cfg_activate(
    request: DeepPartial<CompPlanCfgActivateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_activateDesc,
      CompPlanCfgActivateRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_calc(
    request: DeepPartial<CompPlanCfgCalcRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_calcDesc,
      CompPlanCfgCalcRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_create(
    request: DeepPartial<CompPlanCfgCreateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_createDesc,
      CompPlanCfgCreateRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_deactivate(
    request: DeepPartial<CompPlanCfgDeactivateRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_deactivateDesc,
      CompPlanCfgDeactivateRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_delete(
    request: DeepPartial<CompPlanCfgDelRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_deleteDesc,
      CompPlanCfgDelRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_get(
    request: DeepPartial<CompPlanCfgGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_getDesc,
      CompPlanCfgGetRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_list(
    request: DeepPartial<CompPlanCfgListRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_listDesc,
      CompPlanCfgListRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_cfg_save(
    request: DeepPartial<CompPlanCfgSaveRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_cfg_saveDesc,
      CompPlanCfgSaveRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_res_values_get(
    request: DeepPartial<CompPlanResValuesGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<GenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_res_values_getDesc,
      CompPlanResValuesGetRequest.fromPartial(request),
      metadata,
    );
  }

  comp_plan_rf_res_values_get(
    request: DeepPartial<CompPlanRfGetRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcCompPlancomp_plan_rf_res_values_getDesc,
      CompPlanRfGetRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcCompPlanDesc = { serviceName: "stcs_cmw.StcsWappSvcCompPlan" };

export const StcsWappSvcCompPlancomp_plan_cfg_activateDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_activate",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgActivateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_calcDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_calc",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgCalcRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_createDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_create",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgCreateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_deactivateDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_deactivate",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgDeactivateRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_deleteDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_delete",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgDelRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_get",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_listDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_list",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgListRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_cfg_saveDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_cfg_save",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanCfgSaveRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_res_values_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_res_values_get",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanResValuesGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const StcsWappSvcCompPlancomp_plan_rf_res_values_getDesc: UnaryMethodDefinitionish = {
  methodName: "comp_plan_rf_res_values_get",
  service: StcsWappSvcCompPlanDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return CompPlanRfGetRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
